import { useFormaliteService } from '@europrocurement/l2d-domain';
import { CollectionOpenSearchJsonldOpensearchCollectionRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type OrderNumero = CollectionOpenSearchJsonldOpensearchCollectionRead &
    Record<string, unknown>;

const useOrderNumero = () => {
    const { collectionOpenSearchApi } = useFormaliteService();
    let searchTimeout: number | undefined;

    const searchOrderNumero = (term: string): Promise<Array<OrderNumero>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchTimeout);
            const requestParameters = { q: term };
            searchTimeout = setTimeout(() => {
                collectionOpenSearchApi
                    .apiOpensearchCollectionsNumerosGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<OrderNumero>))
                    .catch(() => reject());
            }, 300);
        });

    return { searchOrderNumero };
};

export default useOrderNumero;
